"use client";

import Link from "next/link";
import { useMemo } from "react";
import type { TPropsWithChildren } from "@/types";

type AppLinkProps = {
	[key: string]: any;
	readonly href: string | null | undefined;
	readonly isSameTab?: boolean;
};

export default function AppLink({
	href,
	children,
	isSameTab,
	...props
}: TPropsWithChildren<AppLinkProps>) {
	const isAbsolute = useMemo(() => href && /^https?:\/\//i.test(href), [href]);

	if (!href)
		return (
			// eslint-disable-next-line react/jsx-no-useless-fragment
			<>{children}</>
		);

	return (
		<>
			{isAbsolute && (
				<a href={href} target={`${isSameTab ? "_self" : "_blank"}`} {...props}>
					{children}
				</a>
			)}

			{
				// When we have relative URLs,
				// use the optimized Link component from Next
				!isAbsolute && (
					<Link href={href} {...props}>
						{children}
					</Link>
				)
			}
		</>
	);
}
